import { useSelector } from 'react-redux';
import { useParams, useRouteMatch } from 'react-router-dom';
import { userSelector } from 'redux/selectors';
import { useGetOrganizationBySlugQuery } from 'services/organizations';

export const useClaimInfo = () => {
  const { networkSlug: slug, employerSlug: companySlug } = useParams();
  const { data, isLoading, isFetching, isError } = useGetOrganizationBySlugQuery({ slug, companySlug });
  const user = useSelector(userSelector);
  const network = data?.network?.collection;

  const isUserSignedIn = Boolean(user?.id);
  const companyDomain = user?.email?.includes('@') ? user.email.split('@').pop() : null;
  const isEmailMatch = companyDomain === data?.company?.domain;

  const isMatch = useRouteMatch('/claim-your-profile/:networkSlug/company/:employerSlug/email_mismatch');

  const isOnboarding = !useRouteMatch('/claim-your-profile');
  const redirectToMismatch = !isMatch && isUserSignedIn && !isEmailMatch && data?.company && !isOnboarding;

  return {
    network,
    company: data?.company,
    user,
    isLoading: isLoading || isFetching,
    isError,
    isUserSignedIn,
    isEmailMatch,
    redirectToMismatch,
    isOnboarding,
  };
};
